import { apiGet, apiPost } from '../utils/api'
import Hotjar from '@hotjar/browser'

export const getSalesOrderConfigAPI = (groupName) => {
  return apiGet(`mgmt/shopSettings/group/${groupName}?level=SHOP`)
}

export const updateSalesOrderConfigAPI = (data, groupName) => {
  Hotjar.event('update_sales_order_config')
  return apiPost(`mgmt/shopSettings/update/${groupName}?level=SHOP`, data)
}



// WEBPACK FOOTER //
// ./src/api/salesOrder.js